module.exports = __webpack_public_path__ + "8cbb4217f5521cb317e9166a0750e548.MP3";